import {from, Observable, of, shareReplay, tap} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {CacheItem} from "./CacheItem";
import {CachingService} from "./caching.service";


export class CacheBlob extends CacheItem {
    constructor(cachingService: CachingService, httpClient: HttpClient, url: string, folder: string, proxyUrl: string) {
        super(cachingService, httpClient, url, folder, proxyUrl);
    }

    protected override fetchCache(url: string, folder: string): Observable<any> {
        return new Observable<any>(sub => {
            //debugger;
            fetch(url).then(response => {
                if (response.status == 200) {
                    const clonedResponse = response.clone();
                    caches.open(folder).then(cache => {
                        //debugger;
                        cache.put(url, clonedResponse).then(a => {
                            //debugger
                            console.log('put file completed')
                            sub.next(url);
                            sub.complete();
                        })
                    })
                }
            }).catch(error => {
                //debugger;
                const msg = (navigator.onLine) ? "cors" : "offline"
                sub.error({code: msg, url: url, message: "fetch fail"});
            })
        })
    }


    getBody(response: Response): Promise<any> {
        return response.blob();
    }

    getData(body): any {
        return this.url;
    }
}
